import type { LeavePolicy } from './types/leave';
import type { EmployeeRecord } from './types/employee';
export type { EmployeeRecord };

export type LeaveAttachmentMetadata = {
  path: string;
  contentType: string;
  size: number;
};

export type LeaveRequestRecord = {
  id: string;
  /**
   * @deprecated Use leavePolicyId and leavePolicyName instead
   */
  type: string;
  /**
   * The ID of the LeavePolicy document this request is for.
   * Path: tenants/{tenantId}/leavePolicies/{leavePolicyId}
   */
  leavePolicyId?: string;
  /**
   * The name of the policy at the time of submission (cached for display).
   * e.g., "Annual Vacation"
   */
  leavePolicyName?: string;
  startDate: string;
  endDate: string;
  days: number;
  status: string;
  reason?: string | null;
  documentRequired?: boolean;
  documentAttached?: boolean;
  attachment?: LeaveAttachmentMetadata | null;
  /** UID of the employee this request is for */
  employeeUid?: string;
  /** Employee ID (doc ID in employees collection) */
  employeeId?: string;
  /** UID of user who created this request */
  createdBy?: string;
};

export type LeaveRequestWrite = {
  createdBy: string;
  tenantId: string;
  /**
   * @deprecated Use leavePolicyId and leavePolicyName instead
   */
  type: string;
  /**
   * The ID of the LeavePolicy document this request is for.
   * Path: tenants/{tenantId}/leavePolicies/{leavePolicyId}
   */
  leavePolicyId?: string;
  /**
   * The name of the policy at the time of submission (cached for display).
   * e.g., "Annual Vacation"
   */
  leavePolicyName?: string;
  startDate: string;
  endDate: string;
  days: number;
  reason: string;
  status: string;
  createdAt: unknown;
  documentRequired: boolean;
  documentAttached: boolean;
  attachment?: LeaveAttachmentMetadata | null;
};

export type AppTestOverrides = {
  employees?: EmployeeRecord[];
  leaveRequests?: LeaveRequestRecord[];
  leavePolicy?: LeavePolicy | null;
  onCreateLeaveRequest?: (input: LeaveRequestWrite) => Promise<{ id?: string } | { id: string }> | { id?: string } | void;
  onSetUserRole?: (input: { uid: string; role: string }) => Promise<void> | void;
};

export function getTestOverrides(): AppTestOverrides | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }

  const win = window as Window & {
    Cypress?: unknown;
    __appTestData?: AppTestOverrides;
  };

  if (!win.Cypress) {
    return undefined;
  }

  return win.__appTestData;
}

export function setTestOverrides(next: AppTestOverrides) {
  if (typeof window === 'undefined') {
    return;
  }

  const win = window as Window & {
    __appTestData?: AppTestOverrides;
  };

  win.__appTestData = next;
}

declare global {
  interface Window {
    __appTestData?: AppTestOverrides;
  }
}
